module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade text-center",
    attrs: {
      "id": "created-order",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('modal-header'), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('paymentResult')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('noticeInfo')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.gtmEvent
    }
  }, [_vm._v(_vm._s(_vm.$t('paymentCompleted')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('contactUsNotice')))]), _vm._v(" "), _c('p', {
    staticClass: "email"
  }, [_vm._v("iplexservice@gmail.com")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66af570b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/createdOrder/CreatedOrder.vue
// module id = 1341
// module chunks = 1